/**
 * Para onde ir depois que um quadro sai da lista — excluído ou abandonado
 * (SPEC-20261027-1958-excluir-quadro-vai-para-o-primeiro, pedido do Cristian: "ao excluir um quadro, ao voltar ele deve se
 * posicionar para o primeiro quadro da lista e sair do excluído").
 *
 * "Primeiro da lista" na MESMA ordem do explorer: favoritos primeiro, depois
 * os outros, cada grupo na ordem em que vem. Sem nenhum outro quadro, null.
 */
export function primeiroQuadroSem(quadros: readonly { id: string; isFavorite?: boolean }[], removidoId: string): string | null {
  const restantes = quadros.filter((q) => q.id !== removidoId)
  return (restantes.find((q) => q.isFavorite) ?? restantes[0])?.id ?? null
}

/** A mesma chave que a tela de Quadros usa para reabrir o último quadro. */
export const CHAVE_ULTIMO_QUADRO = 'orbind.kanbans.last'
